import GridTile from "../../grid/GridTile";
import BigNum from "../../math/BigNum";
import Upgrade from "../Upgrade";

export default class UpgradeCreator {
    /**
     * 
     * @param {string} id 
     */
    constructor(id) {
        /**
         * @constant
         * @type {string}
         */
        this.id = id;
    }

    /**
     * @returns {string}
     */
    getId() {
        return this.id;
    }

    /**
     * @abstract
     * @param {GridTile} tile
     * @returns {Upgrade}
     */
    createMinedUpgrade(tile) {
    }

    /**
     * @abstract
     * @param {BigNum} valueDelta
     * @returns {Upgrade}
     */
    createFreeValueUpgradeFromSave(valueDelta) {        
    }

    /**
     * @abstract
     * @param {string} id 
     * @returns {Upgrade}
     */
    createFreeIdentifierUpgradeFromSave(id) {
    }

    /**
     * Combine two upgrades. The first upgrade will be updated. The second can be removed.
     * @param {Upgrade} upgrade1
     * @param {Upgrade} upgrade2
     */
    combineUpgrades(upgrade1, upgrade2) {
        if (!upgrade1 || !upgrade2) {
            console.log('UpgradeCreator.combineUpgrade() null upgrade');
            return;
        }
        if (upgrade1.getCreatorId() !== upgrade2.getCreatorId()) {
            console.log('UpgradeCreator.combineUpgrade() creatorId mismatch');
            return;
        }
        if (this.id !== upgrade1.getCreatorId() || this.id !== upgrade2.getCreatorId()) {
            console.log('UpgradeCreator.combineUpgrade() creatorId does not match upgrade creator');
            return;
        }

        this.combineUpgradesInternal(upgrade1, upgrade2);
    }

    /**
     * @abstract
     * @param {Upgrade} upgrade1
     * @param {Upgrade} upgrade2
     */
    combineUpgradesInternal(upgrade1, upgrade2) {
    }
}